<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-24 22:02:36
 * @LastEditTime: 2022-02-25 22:46:57
 * @LastEditors: chenguobiao
-->
<template>
  <div class="registration page-normal">
    <common-header selected="user" />
    <div class="page-normal__content">
      <div class="registration--box">
        <div class="registration__header">
          <div class="medal">
            <img src="@/render/assets/images/personal/registration/medal.png" />
          </div>
          <div class="desc">
            <p>恭喜你{{ userInfo.name }}</p>
            <p>
              你已在本国际象棋定级平台考取所有等级，出色的完成了国际象棋所有线上考试并已获得办理纸质证书资格，在此办证过程中，<br />请你仔细阅读以下说明，准确填写信息，以顺利办理国际象棋等级证书！
            </p>
          </div>
        </div>
        <div class="registration__middle">
          <div class="registration--title">
            <div class="line-bar">
              <img
                src="@/render/assets/images/personal/registration/linebar.png"
              />
            </div>
            <div class="registration--title__title">
              国际象棋等级证书领取通知
            </div>
            <div class="line-bar">
              <img
                src="@/render/assets/images/personal/registration/linebar.png"
              />
            </div>
          </div>
          <div class="registration--content" v-if="certificate">
            <p>
              本次办证你将会获得{{
                certificate.available.length * 2
              }}个证书，分别为{{ renderCertificate(certificate.available) }}。
            </p>
            <p class="paragraph--title">一：证书说明</p>
            <p>
              中国国际象棋协会棋士证书介绍：中国国际象棋协会证书由中国国际象棋协会监制，适用于参加各类等级赛、全国棋协大师赛等，证书办理价格为{{
                certificate.available[0] &&
                  certificate.available[0].chessCertificate
              }}元/份。<br />
              智力运动技术证书介绍：智力运动技术等级证书由中国棋院杭州分院（杭州棋院、杭州市智力运动管理中心）颁发，适用于参加各类杭州市等级赛、新锐赛、选拔赛等参赛资格，证书办理价格为{{
                certificate.available[0] &&
                  certificate.available[0].levelCertificate
              }}元/份。
            </p>
            <p class="paragraph--title">二：付费金额（所有金额均为人民币）</p>
            <p>
              <template v-for="level in certificate.available"
                >中国国际象棋协会{{ level.levelName }}级棋士证书{{
                  level.chessCertificate
                }}元/份 + 智力运动技术{{ level.levelName }}级等级证书{{
                  level.levelCertificate
                }}元/份</template
              >
              = {{ certificate.amount }}元
            </p>
            <p class="paragraph--title">三：邮寄方式</p>
            <p>
              证书将通过<strong style="color: red;">顺丰到付</strong
              >寄送！请准确填写以下收件信息：
            </p>
          </div>
        </div>
        <div class="registration__footer">
          <el-form
            :inline="true"
            :model="formData"
            :rules="rules"
            ref="formRef"
          >
            <el-form-item label="收件人：" prop="recipient">
              <el-input v-model="formData.recipient"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="contactNumber">
              <el-input v-model="formData.contactNumber"></el-input>
            </el-form-item>
            <el-form-item label="收件地址：" prop="receiveAddress">
              <el-input v-model="formData.receiveAddress"></el-input>
            </el-form-item>
          </el-form>
          <div class="submit--button" @click="submit">
            <div class="submit--button--bg">
              <img
                src="@/render/assets/images/personal/registration/button.png"
              />
            </div>
            <div class="submit--button--txt">确认办证</div>
          </div>
        </div>
        <div class="registration--tips">
          温馨提示：若有疑问，可以跟客服线下联系！
        </div>
        <!-- <div class="back--home" @click="$router.replace('/home')"><img src="@/render/assets/images/icon_home.png" />返回首页</div> -->
        <common-back :backHome="false" />
      </div>
    </div>
  </div>
</template>

<script>
import store from 'store'
import { personalAPI } from '@/apis'
import CommonHeader from '@/render/components/common/header'
import CommonBack from '@/render/components/common/back'
import { USER_INFO } from '@/config/const'
import { debounce } from '@/render/utils'
export default {
  components: {
    CommonBack,
    CommonHeader,
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return new Error('请输入电话号码')
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        const isPhone = reg.test(value)
        value = Number(value) // 转换为数字
        if (typeof value === 'number' && !isNaN(value)) {
          // 判断是否为数字
          value = value.toString() // 转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) {
            // 判断是否为11位手机号
            callback(new Error('手机号码格式如:138xxxx8754'))
          } else {
            callback()
          }
        } else {
          callback(new Error('请输入电话号码'))
        }
      }
    }
    return {
      userInfo: {
        avatarUrl: '',
        name: '',
      },
      agreementContent: '',
      formData: {
        recipient: '',
        receiveAddress: '',
        contactNumber: '',
      },
      rules: {
        recipient: [
          { required: true, message: '请输入收件人', trigger: 'blur' },
        ],
        receiveAddress: [
          { required: true, message: '请输入收件地址', trigger: 'blur' },
        ],
        contactNumber: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' },
        ],
      },
      certificate: null,
    }
  },
  mounted() {
    this.getCertificate()
    this.userInfo = store.get(USER_INFO)
  },
  watch: {},
  methods: {
    renderCertificate(available) {
      let arrCertificate = []
      available.forEach(level => {
        arrCertificate.push('中国国际象棋协会' + level.levelName + '级棋士证书')
        arrCertificate.push('智力运动技术' + level.levelName + '级等级证书')
      })
      return arrCertificate.join('、')
    },
    async getCertificate() {
      const { data } = await personalAPI.postApplyCertificate()
      this.certificate = data
      // this.agreementContent = result.data ? result.data.content : ''
    },
    submit: debounce(async function() {
      this.$refs.formRef.validate(async (valid, object) => {
        if (valid) {
          const { data } = await personalAPI.postBuyCertificate(this.formData)
          this.$router.push(
            '/personal-payment?type=2&orderNum=' + data.orderNum,
          )
        }
      })
    }),
  },
}
</script>

<style lang="scss" scoped>
.registration {
  &--box {
    position: absolute;
    left: 50%;
    bottom: val(80);
    transform: translateX(-50%);
    width: val(1364);
    height: val(824);
    background: url('../../../assets/images/personal/registration/bg.png')
      no-repeat;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    ::v-deep .back {
      top: val(9);
    }
  }
  &__header {
    display: flex;
    padding-top: val(9);
    padding-left: val(104);
    .medal {
      margin-right: val(20);
      width: val(126);
    }
    .desc {
      padding-top: val(30);
      p {
        &:first-of-type {
          margin-bottom: val(13);
          font-size: val(36);
          line-height: val(36);
          color: #f5d0a2;
        }
        &:last-of-type {
          font-size: val(18);
          line-height: val(26);
          color: #f5d0a2;
        }
      }
    }
  }
  &__middle {
    margin: 0 auto;
    width: val(1220);
    height: val(525);
    padding-top: val(55);
    background: url('../../../assets/images/personal/registration/content-bg.png')
      center no-repeat;
    background-size: contain;
    .registration--title {
      display: flex;
      flex-direction: column;
      align-items: center;
      &__title {
        font-size: val(36);
        line-height: val(51);
        color: #533113;
      }
      .line-bar {
        width: val(270);
        &:last-of-type {
          transform: rotate(180deg);
        }
      }
    }
    .registration--content {
      margin: val(12) auto 0;
      width: val(996);
      height: val(300);
      overflow: auto;
      p {
        font-size: val(16);
        line-height: val(26);
        color: #533113;
        &.paragraph--title {
          margin-top: val(16);
          font-size: val(18);
          font-weight: bold;
        }
      }
    }
  }
  &__footer {
    display: flex;
    align-items: center;
    padding: val(34) val(74) 0;
    .el-form-item {
      float: left;
      margin-bottom: 0;
      ::v-deep {
        .el-form-item__label {
          float: left;
          font-size: val(16);
          color: #ffefdb;
        }
        .el-form-item__content {
          width: val(180);
          float: left;
          .el-input__inner {
            height: val(42);
            line-height: val(42);
          }
        }
      }
    }
    .submit--button {
      cursor: pointer;
      position: relative;
      width: val(245);
      &--txt {
        position: absolute;
        left: val(87);
        top: val(24);
        line-height: val(24);
        font-size: val(18);
        color: #ffefdb;
      }
    }
  }
  &--tips {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 100%);
    text-align: center;
    font-size: val(16);
    color: #302b28;
    opacity: 0.5;
  }
}
</style>
